/**
 * Admin — Regole della pianificazione: la rotta storica.
 *
 * Il pannello (e tutta la spiegazione del contratto PLANNING v2 §6) sta in
 * `features/planning/PlanningPoliciesPanel`, perché lo rende anche la scheda
 * «Pianificazione» di `/admin/policies` («Policy aziendali»), che è la voce di menu.
 * Questa rotta resta in piedi per i link già in giro.
 */
import { createFileRoute } from '@tanstack/react-router';
import { PlanningPoliciesPanel } from '@/features/planning/PlanningPoliciesPanel';

export const Route = createFileRoute('/_app/admin/planning-policies')({
  component: PlanningPoliciesPanel,
});
